import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";

export interface AspenStyle {
    cssOverride: InjectableCss;
}

export const aspenStyles: AspenStyle = {
    cssOverride: {
        css: css`
        /* Custom Aspen CSS Stylings*/
       .button-primary-cta{
            background-color: #F96523 !important;
            border-color: #F96523  !important;
            color: #fff !important;

            &:hover{
                background: hsl(18.5, 95.5%, 39.3%) !important;
                border-color: hsl(18.5, 95.5%, 39.3%) !important;                
            }
       }
       .aspen-content{
            font-size:18px;
            font-weight:400;
       }
       .img-wrapper{
            img{
                display:block;
            }
       }
       .as-card-holder{
        .as-product-holder{
            .as-text-area{
                .as-product-ttl{
                    color: #042359;
                    &:hover{
                        color: #55a9cb;
                        }
                    }
                }
            }					
        }
        address p{
            margin-bottom: 0px;
        }
        p{
            font-family: "Inter Tight",Arial; 
        }
        span{
            font-family: "Inter Tight",Arial; 
        }
        .as-nav-active {
            .as-nav-opener {
                &:after {
                    top: 9px;
                    top: 9px;
                    transform: rotate(-45deg);
                }
        
                &:before {
                    top: 9px;
                    top: 9px;
                    transform: rotate(45deg);
                }
        
                span {
                    opacity: 0;
                }
            }
        }
        
        .as-topbar-active {
            .as-nav-drop {
                height: calc(var(--full-viewport) - 106px);
                top: 112px;
            }
        }
        
        @media (min-width: 520px) {
            .as-topbar-active {
                .as-nav-drop {
                    height: calc(var(--full-viewport) - 90px);
                    top: 96px;
                }
            }
        }
        
        @media (max-width:1023px) {
            .as-nav-active {
                overflow: hidden;
                .as-nav-drop {
                    transform: translateX(0);
                }
            }
        }
        
        .as-wrapper {
            overflow: hidden;
            position: relative;
            width: 100%;
        }
        /* Add to cart popup styles start */
        
        svg {
            height: 100%;
            max-width: 100%;
            vertical-align: top;
        }
        .as-btn {
            color: #fff;
            display: inline-block;
            font-size: 16px;
            letter-spacing: .48px;
            line-height: 1.2;
            text-align: center;
            transition: background .3s ease,color .3s ease;
            vertical-align: top;
        }
        .as-btn-primary {
            color: #fff;
            font-weight: 700;
            &:hover {
                color: #fff;
            }
        }
        .as-btn-outline {
            border: 1px solid #253746;
            color: #253746;
            font-weight: 700;
            &:hover {
                background-color: #253746;
                color: #fff;
            }
        }
        .as-card-holder {
            background: #fff;
            box-shadow: 0 3px 6px rgba(0,0,0,.25);
            margin: 20px 0 0;
            padding: 22px 22px 14px;
            position: absolute;
            right: 0px;
            top: 100%;
            width: 100vw;
            .as-ttl {
                color: #042359;
                display: block;
                font-family: "Inter Tight", Arial;
                font-size: 20px;
                font-weight: 700;
                line-height: 1.2;
                margin: 0 0 10px;
                padding-right: 25px;
            }
            .as-close {
                position: absolute;
                right: 19px;
                top: 17px;
                &:hover {
                    svg {
                        line {
                            stroke: #c8102e;
                        }
                    }
                }
                svg {
                    line {
                        transition: stroke .35s cubic-bezier(.3,.86,.36,.95);
                    }
                }
            }
            .as-product-holder {
                display: flex;
                &.add-to-cart-notes {
                    color: #013d54;
                    font-size: 14px;
                    margin-right: auto;
                    margin-top: 10px;
                    margin-bottom: -10px;
                    white-space: break-spaces;
                    margin-left: auto;
                    a {
                        &:hover {
                            span {
                                text-decoration: underline;
                                text-underline-offset: 2px;
                            }
                        }
                    }
                }
            }
            
            .as-image {
                border: 2px solid #e5e6e5;
                height: 176px;
                margin-right: 18px;
                min-width: 176px;
                width: 176px;
                img {
                    height: 100%;
                    vertical-align: top;
                    width: 100%;
                    object-fit: contain;
                }
            }
            .as-text-area {
                flex: 1 1 auto;
                padding: 23px 0 0;
                a {
                    &:hover {
                        color: #c8102e;
                    }
                }
            }
            .as-subtitle {
                color: #013d54;
                display: block;
                font-size: 14px;
                font-weight: 350;
                letter-spacing: .01em;
                margin-top: -10px;
            }
            .as-product-ttl {
                color: #013d54;
                display: block;
                font-size: 12px;
                font-weight: 700;
                letter-spacing: .15px;
                line-height: 1.2;
                margin: 0 0 29px;
            }
            .as-text {
                display: block;
                font-family: "Inter Tight", Arial;
                font-size: 12px;
                line-height: 1.2;
                margin: 0 0 4px;
            }
            .as-wrap-btn {
                padding-top: 22px;
                .as-btn {
                    display: block;
                    flex-grow: 1;
                    margin: 0 0 11px;
                    text-align: center;
                }
            }
        }
        @media (min-width: 768px) {
            .as-card-holder {
                display: flex;
                flex-direction: column;
                min-height: 302px;
                padding: 15px 23px 21px;
                right: -20px;
                width: 420px;
                .as-ttl {
                    font-size: 23px;
                    margin: 0 0 17px;
                }
                .as-close {
                    right: 22px;
                    top: 19px;
                }
                .as-image {
                    height: 130px;
                    margin-right: 12px;
                    min-width: 130px;
                    width: 130px;
                }
                .as-text-area {
                    padding: 19px 0 0;
                }
                .as-product-ttl {
                    font-size: 15px;
                    margin: 0px;
                }
                .as-text {
                    font-size: 14px;
                    margin: 0 0 4px;
                }
                .as-wrap-btn {
                    display: flex;
                    justify-content: space-between;
                    margin: auto -8px 0;
                    padding-top: 25px;
                    .as-btn {
                        margin: 0 8px;
                    }
                }
            }
        }
        @media (max-width: 1023px) {
            .as-card-holder {
                .as-subtitle {
                    display: none;
                }
            }
            .as-product-holder {
                &.add-to-cart-notes {
                    margin-left: 20px!important;
                }
            }
        }
        @media (max-width: 767px) {
            .as-card-holder {
                .as-wrap-btn {
                    .as-btn {
                        border-radius: 20px;
                        border-width: 2px;
                        font-size: 20px;
                        letter-spacing: .6px;
                        display: inline;
                        width: 50%;
                    }
                    .center{
                        width: 100%;
                    }
                }
            }
        }

        .as-cart-popup {
            .as-close {
                position: absolute;
                right: 0;
                background: none;
                top: 25px;
                font-size: 10px;
                svg {
                    line 
                    {
                        transition:stroke .35s cubic-bezier(.3,.86,.36,.95);
                        stroke:#042359;
                    }
                }
                &:hover {
                    svg {
                        line 
                        {
                            stroke:#042359;
                        }
                    }
                }
            }
        }

        @media (min-width: 768px)
        {
            .as-cart-popup {
                .as-close {
                    right: -20px;
                    top: 25px;
                    font-size: 10px;
                }
            }
            
        }
        
        /* Add to cart popup styles end */
        .pf-breadcrumbs-wrapper{
            max-width: none;
            padding:0;
        }
        @media print {
            .no-print-block, .banner-wrapper, .instruction-text,.mylivechat_inline, [data-test-selector="TopBar"]
            , [data-test-selector="drawer_CookiePolicy"] {
                display: none;
            }
        }
        `,
    },
};
